import React, { useState, useEffect } from "react";
import { Paper, Typography, Divider, TextField, Button } from "@mui/material";
import { changeForgotPassword } from "../../ApiService/ApiService";
import PropTypes from "prop-types";
import { isValidOTP } from "../../Utils/validFormDetails";
import CustomDialog from "../../Components/CustomDialog";

function ForgotPassword({ email, schoolId, isFlipped, setisFlipped }) {
  const [formData, setFormData] = useState({
    schoolId: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialogData, setDialogData] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      schoolId: schoolId,
      email: email,
    }));
  }, [schoolId, email]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCloseDialog = () => {
    setDialogData({
      visible: false,
      title: "",
      message: "",
      buttons: [],
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !formData.schoolId ||
      !formData.email ||
      !formData.password ||
      !formData.confirmPassword ||
      !formData.otp
    ) {
      setDialogData({
        visible: true,
        title: "Error",
        message: "Please fill all the details",
        buttons: [{ name: "Close", onPress: () => {} }],
      });
      return;
    }
    if (!isValidOTP(formData.otp)) {
      setDialogData({
        visible: true,
        title: "Error",
        message: "Please enter a valid 6-digit OTP",
        buttons: [{ name: "Close", onPress: () => {} }],
      });
      return;
    }
    setLoading(true);
    try {
      const response = await changeForgotPassword(formData);
      if (response) {
        if (response?.data?.status === 200) {
          setDialogData({
            visible: true,
            title: "Success",
            message: "Password changed successfully",
            buttons: [
              { name: "Close", onPress: () => setisFlipped(!isFlipped) },
            ],
          });
          setFormData({
            schoolId: "",
            email: "",
            password: "",
            confirmPassword: "",
            otp: "",
          });
        } else {
          const errorMessage =
            response?.data?.errorMessage || "Something went wrong!";
          setDialogData({
            visible: true,
            title: "Error",
            message: errorMessage,
            buttons: [{ name: "Close", onPress: () => {} }],
          });
        }
      } else {
        setDialogData({
          visible: true,
          title: "Error",
          message: "Invalid response from the server",
          buttons: [{ name: "Close", onPress: () => {} }],
        });
      }
    } catch (error) {
      setDialogData({
        visible: true,
        title: "Error",
        message: "Couldn't change password",
        buttons: [{ name: "Close", onPress: () => {} }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialogData.visible}
        title={dialogData.title}
        message={dialogData.message}
        buttons={dialogData.buttons}
        onClose={handleCloseDialog}
      />
      <Paper
        elevation={3}
        sx={{
          padding: 5,
          boxShadow: "0px 4px 80px rgba(0, 0, 0, 0.1)",
          ml: 5,
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: "block" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Forgot Password
          </Typography>
          <Divider sx={{ p: 1 }} />
          <Typography variant="h6" sx={{ color: "gray", textAlign: "center" }}>
            Welcome to{" "}
            <span
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              SchoolMidas
            </span>
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="School ID"
            name="schoolId"
            placeholder="Eg. SMS-123"
            value={schoolId}
            required
            disabled
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="Email"
            name="email"
            placeholder="Eg. john@gmail.com"
            value={email}
            required
            disabled
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="OTP"
            name="otp"
            value={formData.otp}
            onChange={handleChange}
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ textTransform: "unset", mt: 2, height: "50px" }}
            disabled={loading}
          >
            {loading ? "Loading..." : "Submit"}{" "}
          </Button>
          <Button
            variant="contained"
            fullWidth
            color="inherit"
            sx={{ textTransform: "unset", mt: 2, height: "50px" }}
            onClick={() => setisFlipped(!isFlipped)}
          >
            Back
          </Button>
        </form>
      </Paper>
    </>
  );
}

ForgotPassword.propTypes = {
  email: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
  isFlipped: PropTypes.bool.isRequired,
  setisFlipped: PropTypes.func.isRequired,
};

export default ForgotPassword;
